export default __webpack_public_path__ + "static/media/Group 1393.f733c322.png";